import Flex from 'typescript-styled-flex'
import { NavLink } from 'react-router-dom'
import styled, { ITheme } from '../../theme'

const GoHome = styled(Flex.withComponent(NavLink) as any)<IItemProps>`
  color: white;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  transform: translateZ(0);
  border: 0;
  background: 0 0;
  padding: 0 ${({ size }) => (size ? 0.75 * size : 0.75)}em;
  font-size: ${({ size }) => (size ? 1.375 * size : 1.375)}em;
  height: 100%;
  color: #000;

  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    color: #fff;
  }

  @media (min-width: ${(theme: ITheme) => theme.theme.breakpoints.mobile}) {
    &:hover {
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
  & > span {
    font-size: ${({ size }) => (size ? 0.6 * size : 0.6)}em;
  }
`

export default GoHome

export interface IItemProps {
  active?: boolean
  size?: number
}
